var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define('score_ccf/XPerience/Conditions/SlideChangedCondition',["require", "exports", "jquery", "score_ccf/XPerience/XPConditionBase"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var $ = require("jquery");
    var XPConditionBase_1 = require("score_ccf/XPerience/XPConditionBase");
    var ComponentSlideChangedCondition = /** @class */ (function (_super) {
        __extends(ComponentSlideChangedCondition, _super);
        function ComponentSlideChangedCondition(attributes) {
            return _super.call(this, attributes) || this;
        }
        ComponentSlideChangedCondition.prototype.setup = function (component) {
            var _this = this;
            if (!component) {
                throw new Error('Cannot setup a condition without \'component\' instance');
            }
            $(component).on('afterChange.slider', function () {
                _this.true();
            });
        };
        return ComponentSlideChangedCondition;
    }(XPConditionBase_1.XPConditionBase));
    exports.default = ComponentSlideChangedCondition;
    ;
});
//# sourceMappingURL=SlideChangedCondition.js.map;
